import React from "react";
import { findItemByName } from "../../../settings/utils/functions";

const WPHeader = ({ items, activeItem, loading, onSaveData }) => {
  const item = findItemByName(items, activeItem);
  const wp = "wp-dashboard";

  return (
    <div className={`${wp}-header-main`}>
      <div className={`${wp}-header-wrapper`}>
        <div className={`${wp}-header-logo-container`}>
          <div className={`${wp}-header-logo`}>
            {item.logo}
          </div>
        </div>

        <div className={`${wp}-header-title-container`}>
          <div className={`${wp}-header-title`}>
            <h2>{item.title}</h2>
          </div>
        </div>

        <div className="saveBtnWrap">
          <button className={`${loading ? "isDisabled paddingRight" : ""}`} onClick={onSaveData} disabled={loading}>Save Changes {loading && <span className="saveBtn-loader"></span>}</button>
        </div>
      </div>
    </div>
  );
};

export default WPHeader;
